import { Objective, OBJECTIVE_TYPE } from "../../interfaces";

import "../../styles/objective.css";

export const ObjectiveEntry = ({ objective }: { objective: Objective }) => {
    return (
        <div className="objectiveEntry">
            <div className="title">{objective.title}</div>
            <div className="progress">
                {objective.value} /{" "}
                {objective.type === OBJECTIVE_TYPE.FACT
                    ? "1"
                    : `${objective.goal}`}
            </div>
        </div>
    );
};
